import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Form from './clienteAreaForm';
import Aguardando from '../common/template/aguardando';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';
import FormatUtils from '../common/formatUtils/FormatUtils';

import {
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista
} from './clienteAreaActions';

const columns = [
    { field: 'nome', type: 'text' },
    { field: 'area_propria', type: 'number' },
    { field: 'area_arrendada', type: 'number' },
    { field: 'area_total', type: 'number' }
];

const calcularAreaTotal = area =>
    Number(area.area_propria || 0) +
    Number(area.area_arrendada || 0);

const formatarHectares = valor =>
    `${FormatUtils.formatarValorTela(valor || 0, 2)} ha`;

const ClienteArea = props => {

    const [linhaSelecionada, setLinhaSelecionada] = useState(null);
    const [pesquisar, setPesquisar] = useState('');
    const [sort, setSort] = useState({
        field: 'nome',
        direction: 'asc'
    });

    const resumoAreas = (props.lista || []).reduce(
        (resumo, area) => ({
            quantidade: resumo.quantidade + 1,
            areaPropria:
                resumo.areaPropria + Number(area.area_propria || 0),
            areaArrendada:
                resumo.areaArrendada + Number(area.area_arrendada || 0)
        }),
        {
            quantidade: 0,
            areaPropria: 0,
            areaArrendada: 0
        }
    );

    useEffect(() => {
        if (props.cliente && props.cliente.id) {
            props.setModoTela('lista');
            props.getLista(props.cliente.id);
        }
    }, [props.cliente && props.cliente.id]);

    const onSort = field => {
        setSort(prev => {
            let direction = 'asc';

            if (prev.field === field) {
                direction = prev.direction === 'asc' ? 'desc' : 'asc';
            }

            return { field, direction };
        });
    };

    const filtrar = () => {
        const termoPesquisa = (pesquisar || '').trim();

        const listaFiltrada = (props.lista || [])
            .map(item => ({
                ...item,
                area_total: calcularAreaTotal(item)
            }))
            .filter(item => {
                if (!termoPesquisa) {
                    return true;
                }

                const texto = `
                    ${item.nome || ''}
                    ${item.observacao || ''}
                ${formatarHectares(item.area_propria)}
                ${formatarHectares(item.area_arrendada)}
                ${formatarHectares(item.area_total)}
                `.toUpperCase();

                return termoPesquisa
                    .toUpperCase()
                    .split('+')
                    .filter(p => p.trim())
                    .every(p => texto.includes(p.trim()));
            });

        return sortData(listaFiltrada, sort, columns);
    };

    const montarExcel = lista => {
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        return (
            <ExcelSheet
                data={lista.map(item => ({
                    ...item,
                    area_propria:
                        formatarHectares(item.area_propria),
                    area_arrendada:
                        formatarHectares(item.area_arrendada),
                    area_total:
                        formatarHectares(calcularAreaTotal(item))
                }))}
                name='Áreas'
            >
                <ExcelColumn label='Cliente' value={() => props.cliente.razao_social} />
                <ExcelColumn label='Área' value='nome' />
                <ExcelColumn label='Área Própria' value='area_propria' />
                <ExcelColumn label='Área Arrendada' value='area_arrendada' />
                <ExcelColumn label='Área Total' value='area_total' />
                <ExcelColumn label='Observação' value='observacao' />
                <ExcelColumn label='Usuário da Inclusão' value='nome_usuario_inclusao' />
                <ExcelColumn label='Usuário da Alteração' value='nome_usuario_alteracao' />
            </ExcelSheet>
        );
    };

    const renderLista = () => {
        const ExcelFile = ReactExport.ExcelFile;
        const lista = filtrar();

        const alturaTabela = window.innerWidth < 631
            ? window.innerHeight - 300
            : window.innerHeight - 220;

        return (
            <ContentCard>
                <ContentCardHeader>
                    <Row>
                        <InputPesquisa
                            cols='12 6 3 1'
                            label='Pesquisar'
                            minWidth={344}
                            onChange={value => setPesquisar(value)}
                        />

                        <div
                            style={{
                                marginTop: 8,
                                width: props.embutido ? 'auto' : 350
                            }}
                        >
                            {!props.embutido &&
                                <button
                                    type='button'
                                    className='btn btn-app bg-light'
                                    style={{ marginLeft: 2, minWidth: 75 }}
                                    onClick={() => props.onVoltar()}
                                >
                                    <i className='fas fa-chevron-left'></i> Voltar
                                </button>}

                            <button
                                type='button'
                                className='btn btn-app bg-success'
                                style={{ marginLeft: 2, minWidth: 75 }}
                                onClick={() => {
                                    props.setModoTela('cadastro', {});
                                    props.initForm({
                                        id_cliente: props.cliente.id,
                                        contatos: [
                                            {
                                                id: null,
                                                nome: '',
                                                celular: '',
                                                email: ''
                                            }
                                        ]
                                    });
                                }}
                            >
                                <i className='fas fa-plus'></i> Adicionar
                            </button>

                            <button
                                type='button'
                                className='btn btn-app bg-primary'
                                style={{ marginLeft: 2, minWidth: 75 }}
                                onClick={() => props.getLista(props.cliente.id)}
                            >
                                <i className='fas fa-sync-alt'></i> Atualizar
                            </button>

                            <ExcelFile
                                filename='Áreas do Cliente'
                                element={
                                    <button
                                        type='button'
                                        className='btn btn-app bg-info'
                                        style={{ marginLeft: 2, minWidth: 75 }}
                                    >
                                        <i className='fas fa-file-excel'></i> Exportar
                                    </button>
                                }
                            >
                                {montarExcel(lista)}
                            </ExcelFile>
                        </div>
                    </Row>
                </ContentCardHeader>

                <ContentCardBody>
                    <Table
                        responsive
                        border
                        alturaFixa
                        striped
                        maxHeight={alturaTabela}
                    >
                        <THead>
                            <Tr>
                                <ThSort
                                    field='nome'
                                    label='Área'
                                    width={260}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='area_propria'
                                    label='Área Própria'
                                    width={130}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='area_arrendada'
                                    label='Área Arrendada'
                                    width={140}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='area_total'
                                    label='Área Total'
                                    width={130}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <Th sticky alignCenter width={50}></Th>
                            </Tr>
                        </THead>

                        <TBody>
                            {lista.map((item, i) => (
                                <Tr
                                    key={item.id}
                                    backgroundColor={
                                        linhaSelecionada === item.id
                                            ? '#bcc7eb'
                                            : i % 2 === 0
                                                ? '#ffffff'
                                                : '#f5f5f5'
                                    }
                                >
                                    <Td onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {item.nome}
                                    </Td>

                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {formatarHectares(item.area_propria)}
                                    </Td>

                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {formatarHectares(item.area_arrendada)}
                                    </Td>

                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {formatarHectares(item.area_total)}
                                    </Td>

                                    <Td alignCenter minWidth={130} maxWidth={130}>
                                        <ButtonTable
                                            type='warning'
                                            width={32}
                                            small
                                            icon='fas fa-pencil-alt'
                                            visible
                                            title='Editar'
                                            event={() => {
                                                props.setModoTela('cadastro', { ...item });
                                                props.initForm({
                                                    ...item,
                                                    area_propria: FormatUtils.formatarValorTela(
                                                        item.area_propria,
                                                        2
                                                    ),
                                                    area_arrendada: FormatUtils.formatarValorTela(
                                                        item.area_arrendada,
                                                        2
                                                    )
                                                });
                                            }}
                                        />

                                        <ButtonTable
                                            type='danger'
                                            width={32}
                                            small
                                            icon='fas fa-trash-alt'
                                            visible
                                            title='Excluir'
                                            event={() => {
                                                props.setModoTela('exclusao', { ...item });
                                                props.initForm({
                                                    ...item,
                                                    area_propria: FormatUtils.formatarValorTela(
                                                        item.area_propria,
                                                        2
                                                    ),
                                                    area_arrendada: FormatUtils.formatarValorTela(
                                                        item.area_arrendada,
                                                        2
                                                    )
                                                });
                                            }}
                                        />
                                    </Td>
                                </Tr>
                            ))}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    };

    return (
        <div style={{ marginBottom: 280 }}>
            <Aguardando aguardando={props.aguardando} />

            <div
                style={{
                    width: '100%',
                    marginTop: props.embutido ? 18 : 0,
                    marginBottom: 18,
                    padding: '16px 22px',
                    borderRadius: 12,
                    background: props.embutido
                        ? 'linear-gradient(135deg, #087df1 0%, #075bb5 100%)'
                        : 'linear-gradient(135deg, #062042 0%, #062042 100%)',
                    color: '#fff',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 12,
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    boxShadow: props.embutido
                        ? '0 5px 14px rgba(8, 105, 210, .22)'
                        : '0 3px 10px rgba(0,0,0,.18)'
                }}
            >

                <div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            fontSize: 22,
                            fontWeight: 600,
                            lineHeight: 1.2
                        }}
                    >
                        <i className='fas fa-map-marked-alt' />
                        Áreas do cliente
                    </div>

                </div>

                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'flex-end',
                        gap: 10
                    }}
                >
                    {[
                        {
                            label: 'Quantidade de áreas',
                            valor: resumoAreas.quantidade
                        },
                        {
                            label: 'Total área própria',
                            valor: formatarHectares(
                                resumoAreas.areaPropria
                            )
                        },
                        {
                            label: 'Total arrendada',
                            valor: formatarHectares(
                                resumoAreas.areaArrendada
                            )
                        }
                    ].map(indicador => (
                        <div
                            key={indicador.label}
                            style={{
                                minWidth: 145,
                                padding: '9px 13px',
                                borderRadius: 9,
                                background: 'rgba(255, 255, 255, .13)',
                                border:
                                    '1px solid rgba(255, 255, 255, .16)'
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 11,
                                    opacity: .82,
                                    textTransform: 'uppercase',
                                    letterSpacing: .4
                                }}
                            >
                                {indicador.label}
                            </div>

                            <div
                                style={{
                                    marginTop: 2,
                                    fontSize: 18,
                                    fontWeight: 700
                                }}
                            >
                                {indicador.valor}
                            </div>
                        </div>
                    ))}
                </div>

            </div>

            {props.modoTela === 'cadastro' &&
                <Form
                    cliente={props.cliente}
                    onSubmit={props.salvar}
                />}

            {props.modoTela === 'exclusao' &&
                <Form
                    excluir
                    cliente={props.cliente}
                    onSubmit={props.excluir}
                />}

            {props.modoTela === 'lista' &&
                renderLista()}
        </div>
    );
};

const mapStateToProps = state => ({
    modoTela: state.clienteArea.modoTela,
    aguardando: state.clienteArea.aguardando,
    lista: state.clienteArea.lista
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ClienteArea);
